(function (angular) {
  "use strict";

  angular.module("Toyota.Services").service("CustomEasings", function () {
    var exports = this;
    var easingFunctionGenerators = {};

    exports.curves = {
      EASE_IN_OUT_EXPO: "easeInOutExpo",
    };

    /*
     * This is derived from jquery.easing.js -> easeInOutExpo, but with different values
     * for base and power so that it can be tweaked to look "tight" / "satisfying".
     */
    easingFunctionGenerators[exports.curves.EASE_IN_OUT_EXPO] = function (params) {
      return function (x, t, b, c, d) {
        var tWorking = t;

        if (t === 0) {
          return b;
        }

        if (t === d) {
          return b + c;
        }

        if ((tWorking /= d / 2) < 1) {
          return (c / 2) * Math.pow(params.base, params.exponent * (tWorking - 1)) + b;
        }

        return (c / 2) * (-Math.pow(params.base, -params.exponent * --tWorking) + 2) + b;
      };
    };

    exports.ensureAvailableForAnimate = function (id, easingType, generatorParams) {
      angular.element.easing[id] = easingFunctionGenerators[easingType](generatorParams);
    };

    return exports;
  });
})(window.angular);
